import React from 'react';
import { connect } from 'react-redux';
import { PaymentDetailsController } from './controller';

const mapStateToProps = () => ({});

const mapDispatchToProps = {};

type ComponentProps = React.ComponentProps<typeof PaymentDetailsController>;
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;
type OwnProps = Omit<ComponentProps, keyof (StateProps & DispatchProps)>;

export const PaymentDetailsControllerConnect = connect<
  StateProps,
  DispatchProps,
  OwnProps
>(
  mapStateToProps,
  mapDispatchToProps
)(PaymentDetailsController);
